import { render, staticRenderFns } from "./modal-opt-in-mobile-prompt.vue?vue&type=template&id=504a08bc&"
import script from "./modal-opt-in-mobile-prompt.vue?vue&type=script&lang=js&"
export * from "./modal-opt-in-mobile-prompt.vue?vue&type=script&lang=js&"
import style0 from "./modal-opt-in-mobile-prompt.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./modal-opt-in-mobile-prompt.vue?vue&type=style&index=1&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports